import { Paper, Typography } from "@mui/material";
import FamiliesTabs from "./FamiliesTabs";
import { Box, Grid } from "@mui/system";
import "./Families.css"

const Families = () => {
  return (
    <>
      <Paper>
        <Box sx={{ padding: "16px 16px 0px" }}>
          <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
            <Grid size={12}>
              <Typography variant="h3" sx={{ fontSize: "24px" }}>
                Families
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "14px" }}>
                Groups of brands within an interface, processed together at each collection step. Overview by interface, step, or brand.
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <FamiliesTabs />
      </Paper>
    </>
  );
};

export default Families;
